import React, { FC } from 'react';
import { FormControlLabelProps } from '@mui/material';

import { StyledFormControlLabel, StyledCheckbox } from './styled';
import { CheckboxProps } from '../types';

export const Checkbox: FC<CheckboxProps> = (props) => {
  //initial props
  const initialProps = {
    color: props.color,
    size: props.size || `medium`
  };

  return <StyledCheckbox {...props} color={initialProps.color} size={initialProps.size} />;
};

export const FormControlLabel: FC<FormControlLabelProps> = (props) => {
  return <StyledFormControlLabel control={props.control} label={props.label} />;
};
